<template>
    <div>
        <div class="container">
            <div class="name" @click="showDetail = !showDetail">
                <div style="font-size:16rem;color:#7fc6fd">{{name || ''}}</div>
                <img :src="showDetail ? require('@/assets/img/箭头下.png') : require('@/assets/img/箭头右.png')" alt="">
            </div>
            <!-- <transition name="test"> -->
                <div class="data" :class="{active: showDetail}">
                    <div class="dataLine" v-for="(value,key,index) in details" :key="index">
                        <div class="key">{{key}}</div>
                        <div class="line"></div>
                        <div class="value">{{value}}</div>
                    </div>
                </div>
            <!-- </transition> -->
        </div>
    </div>
</template>

<script>
    export default {
        name: "ExpandTable",
        props: ["name", "details"],
        data() {
            return {
                showDetail: true,
            };
        },
        created() {},
        mounted() {},
        methods: {},
    };
</script>

<style scoped lang="less">
    .container {
        width: 100%;

        .name {
            width: 100%;
            .h(38);
            border-bottom: 1px solid rgba(255, 255, 255, 0.15);
            background: rgba(68, 173, 246, 0.22);
            padding: 0 240/192vw;
            cursor: pointer;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }

        .active {
            max-height: 50vh !important;
        }
        .data {
            width: 100%;
            max-height: 0;
            font-size: 14rem;
            color: rgba(96, 169, 226, 1);
            overflow: hidden;
            transition: all 0.4s;

            .dataLine {
                width: 100%;
                // min-height: 470/108vh;
                // .h(47);
                //line-height: 470/108vh;
                padding: 0 240/192vw;
                border-bottom: 1px solid rgba(255, 255, 255, 0.15);
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: stretch;

                .key {
                    width: 35%;
                    display: flex;
                    align-items: center;
                    line-height: 1.5;
                }

                .line{
                    width: 1px;
                    height:inherit;
                    min-height: 470/108vh;
                    max-height: 50vh;
                    background: rgba(255, 255, 255, 0.15);
                }

                .value {
                    width: 65%;
                    display: flex;
                    align-items: center;
                    line-height: 1.5;
                    padding: 0 200/192vw;
                }
            }
        }
    }

    // .test-enter,
    // .test-leave-to {
    //     max-height: 0;
    // }

    // .test-enter-active,
    // .test-leave-active {
    //     max-height: 99999;
    //     // transition: max-height 0.5s
    // }
</style>